import 'css-chunksrc/client/scenes/projectCreationForm/zoneSelection/loader/styles.scss';export default {
  "loader": "_loader_yj3ca_1",
  "name": "_name_yj3ca_11",
  "icon": "_icon_yj3ca_16"
};